"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import type { ReactNode } from "react";
import { memo } from "react";
export interface Step {
  iconHighlight?: ReactNode;
  id: number;
  text: string;
  title: string;
}
const StepColumn = memo(t0 => {
  const $ = _c(14);
  const {
    title,
    text,
    iconHighlight
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("group h-fit bg-card p-10 md:h-full xl:p-12", "transition-all duration-300 ease-in-out", "hover:bg-primary hover:text-white");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== iconHighlight) {
    t2 = iconHighlight && <span className="flex items-center text-primary transition-all duration-250 group-hover:text-white">{iconHighlight}</span>;
    $[1] = iconHighlight;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("mt-2 font-bold text-4xl transition-colors duration-300", "text-primary group-hover:text-white");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== title) {
    t4 = <h3 className={t3} data-source="lc">{title}</h3>;
    $[4] = title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <div className="mb-3 grid grid-flow-col justify-start gap-x-4 lg:mb-5 lg:block">{t2}{t4}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== text) {
    t6 = <p className="text-lg transition-colors duration-300 group-hover:text-white" data-source="lc">{text}</p>;
    $[9] = text;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <li className={t1}>{t5}{t6}</li>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
});
StepColumn.displayName = "StepColumn";
export interface ApplicationProcessSliderProps {
  steps: Step[];
}
export default function ApplicationProcessSlider(t0) {
  const $ = _c(4);
  const {
    steps
  } = t0;
  let t1;
  if ($[0] !== steps) {
    t1 = steps.map(_temp);
    $[0] = steps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="grid auto-cols-fr grid-flow-row gap-y-5 lg:grid-flow-col lg:gap-x-5 xl:gap-x-8">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(step) {
  return <StepColumn key={step.id} {...step} />;
}